import type { EnvironmentId } from "@cmmd-forge/contracts";
import type { ChatImageAttachment } from "../../types";
import { useAttachmentDownload } from "./useAttachmentDownload";

export function ImageAttachmentDownload({
  environmentId,
  image,
}: {
  readonly environmentId: EnvironmentId;
  readonly image: ChatImageAttachment;
}) {
  const { download, error, pending } = useAttachmentDownload({
    environmentId,
    attachmentId: image.id,
    filename: image.name,
  });
  return (
    <button
      type="button"
      className="flex min-h-[72px] w-full items-center justify-center px-2 py-3 text-center text-[11px] text-muted-foreground/70 hover:bg-muted/60"
      aria-label={error ?? `Download ${image.name}`}
      onClick={download}
    >
      {error ?? (pending ? "Downloading..." : `Download ${image.name}`)}
    </button>
  );
}
